/**
 * Companies whose mailboxes are synced into the email archive (REG-817).
 * Email views show one company at a time, Skyline first and by default, so
 * Region Capital's inbox stays out of Skyline's view unless asked for.
 */
export const EMAIL_COMPANIES = [
  { key: 'skyline', label: 'Skyline', domain: 'skylinecaps.com' },
  { key: 'region', label: 'Region', domain: 'regioncapitalgroup.com' },
] as const;

export type EmailCompanyDomain = (typeof EMAIL_COMPANIES)[number]['domain'];

export const DEFAULT_EMAIL_DOMAIN: EmailCompanyDomain = EMAIL_COMPANIES[0].domain;

export function mailboxDomain(email: string | null | undefined): string {
  return (email ?? '').trim().toLowerCase().split('@')[1] ?? '';
}
